import React, { Component } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {
    Mail,
    Person,
    Notifications,
    Home,
    Edit,
    Favorite,
    LocalOffer,
    Money,
    Info,
    ListAlt,
    Email,
    Call,
    Share,
    OndemandVideo,
    CalendarToday,
    Help,
    Star,
    Chat,
    Group,
    InsertDriveFileOutlined,
    ChatOutlined,
    HistoryOutlined,
    DescriptionOutlined
} from '@material-ui/icons';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import { Link, NavLink } from 'react-router-dom';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants';
import { FormattedMessage, injectIntl } from 'react-intl';
import { store } from '../../store';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { ListItemSecondaryAction } from '@material-ui/core';
import { getCookies } from '../../utils/getToken';

var drawerTextColor = "#000000"
var authToken = getCookies();

const styles = theme => ({
    listItem: {
        color: drawerTextColor
    },
    icon: {
        color: drawerTextColor
    }
});

const navbarItemsonlynotification = [

    {
        key: 'notifications',
        label: 'Notifications',
        renderContent: classes => <Notifications className={classes.icon} />,
        link: '/notification/list'
    }
]

const navbarItems = [

    {
        key: 'home',
        label: 'Home',
        renderContent: classes => <Home className={classes.icon} />,
        link: '/user/dashboard'
    },
    {
        key: 'booking',
        label: 'Manage Bookings',
        renderContent: classes => <Edit className={classes.icon} />,
        link: '/user/manage_bookings'
    },
    {
        key: 'Refer & Earn',
        label: 'Refer a Friend',
        renderContent: classes => <Share className={classes.icon} />,
        link: '/user/refer_friend'
    },
    {
        key: 'Tutorials',
        label: 'Tutorials',
        renderContent: classes => <OndemandVideo className={classes.icon} />,
        link: '/user/tutorials'
    },
    // {
    //     key: 'services',
    //     label: 'Services',
    //     renderContent: classes => <ChatOutlined className={classes.icon} />,
    //     link: '/user/services'
    // },
    // {
    //     key: 'Profile',
    //     label: 'Profile',
    //     renderContent: classes => <Person className={classes.icon} />,
    //     link: '/user/profile'
    // },
    // {
    //     key: 'notifications',
    //     label: 'Notifications',
    //     renderContent: classes => <Notifications className={classes.icon} />,
    //     link: '/notification/list'
    // },
    // {
    //     key: 'inbox',
    //     label: 'Chat',
    //     renderContent: classes => <ChatOutlined className={classes.icon} />,
    //     link: '/user/chat'
    // },
    // {
    //     key: 'address',
    //     label: 'Addresses',
    //     renderContent: classes => <Email className={classes.icon} />,
    //     link: '/user/address'
    // },

    // {
    //     key: 'booking',
    //     label: 'Manage Bookings',
    //     renderContent: classes => <Edit className={classes.icon} />,
    //     link: '/user/booking'
    // },
    // {
    //     key: 'newbooking',Manage Bookings
    //     label: 'Add New Request',
    //     renderContent: classes => <InsertDriveFileOutlined className={classes.icon} />,
    //     link: '/'
    // },
    // {
    //     key: 'recurringbooking',
    //     label: 'Recurring Bookings',
    //     renderContent: classes => <HistoryOutlined className={classes.icon} />,
    //     link: '/recurringbookings'
    // },

    // {
    //     key: 'blockedproviders',
    //     label: 'Blocked Providers',
    //     renderContent: classes => <Person className={classes.icon} />,
    //     link: '/blockprovider'
    // },
    // {
    //     key: 'maintenancelog',
    //     label: 'Maintenance Log',
    //     renderContent: classes => <DescriptionOutlined className={classes.icon} />,
    //     link: '/maintenancelog'
    // },
    // {
    //     key: 'bookingcalendar',
    //     label: 'Booking Calendar',
    //     renderContent: classes => <CalendarToday className={classes.icon} />,
    //     link: '/bookingcalendar'
    // },
    /* {
        key: 'favourite',
        label: 'Favourites',
        renderContent: classes => <Favorite className={classes.icon} />,
        link: '/user/favourite'
    }, */
    // {
    //     key: 'promo',
    //     label: 'Offers',
    //     renderContent: classes => <LocalOffer className={classes.icon} />,
    //     link: '/promocode/list'
    // },
    // {
    //     key: 'SOS',
    //     label: 'SOS',
    //     renderContent: classes => <Call className={classes.icon} />,
    //     link: '/sos'
    // },
    // {
    //     key: 'refer',
    //     label: 'Refer and Earn',
    //     renderContent: classes => <Share className={classes.icon} />,
    //     link: '/refer'
    // },

    {
        key: 'help',
        label: 'Help',
        renderContent: classes => <Help className={classes.icon} />,
        link: '/help'
    }


    // {
    //     key: 'help',
    //     label: 'Help',
    //     renderContent: classes => <Info className={classes.icon} />,
    //     link: '/user/help'
    // }
];

const navbarUnverifiedProviderItems = [
    {
        key: 'home',
        label: 'Home',
        renderContent: classes => <Home className={classes.icon} />,
        link: '/user/profile'
    },
    {
        key: 'Profile',
        label: 'Profile',
        renderContent: classes => <Person className={classes.icon} />,
        link: '/user/profile'
    },
    {
        key: 'booking',
        label: 'Manage Bookings',
        renderContent: classes => <Edit className={classes.icon} />,
        link: '/user/profile'
    },
    {
        key: 'Todays Booking',
        label: 'Todays Bookings',
        renderContent: classes => <CalendarToday className={classes.icon} />,
        link: '/user/profile'
    },
    {
        key: 'Tutorials',
        label: 'Tutorials',
        renderContent: classes => <OndemandVideo className={classes.icon} />,
        link: '/user/profile'
    },

    {
        key: 'Help',
        label: 'Help',
        renderContent: classes => <Help className={classes.icon} />,
        link: '/help'
    },

];

const navbarProviderItems = [
    {
        key: 'home',
        label: 'Home',
        renderContent: classes => <Home className={classes.icon} />,
        // link: '/user/dashboard'
        link: '/provider/dashboard'
    },
    {
        key: 'Profile',
        label: 'Profile',
        renderContent: classes => <Person className={classes.icon} />,
        link: '/user/profile'
    },

    // {
    //     key: 'notifications',
    //     label: 'Notifications',
    //     renderContent: classes => <Notifications className={classes.icon} />,
    //     link: '/notification/list'
    // },


    // {
    //     key: 'address',
    //     label: 'Addresses',
    //     renderContent: classes => <Home className={classes.icon} />,
    //     link: '/user/address'
    // },

    // {
    //     key: 'booking',
    //     label: 'Manage Requests',
    //     renderContent: classes => <Edit className={classes.icon} />,
    //     link: '/provider/booking'
    // },

    // new route for manage bookings - shraddha
    {
        key: 'booking',
        label: 'Manage Bookings',
        renderContent: classes => <Edit className={classes.icon} />,
        link: '/provider/manage_bookings'
    },
    {
        key: 'Todays Booking',
        label: 'Todays Bookings',
        renderContent: classes => <CalendarToday className={classes.icon} />,
        link: '/provider/manage_todays_bookings'
    },

    // {
    //     key: 'pendingbooking',
    //     label: 'Initiated Services',
    //     renderContent: classes => <Edit className={classes.icon} />,
    //     link: '/provider/pendingbooking'
    // },


    // {
    //     key: 'service',
    //     label: 'Manage Services',
    //     renderContent: classes => <ListAlt className={classes.icon} />,
    //     link: '/provider/service'
    // },

    // {
    //     key: 'addservice',
    //     label: 'Add Service',
    //     renderContent: classes => <Edit className={classes.icon} />,
    //     link: '/provider/service/create'
    // },
    // {
    //     key: 'employee',
    //     label: 'Manage Employee',
    //     renderContent: classes => <Group className={classes.icon} />,
    //     link: '/employees'
    // },

    // {
    //     key: 'review',
    //     label: 'Review and Rating',
    //     renderContent: classes => <Star className={classes.icon} />,
    //     link: '/review'
    // },

    // {
    //     key: 'inbox',
    //     label: 'Chat',
    //     renderContent: classes => <Email className={classes.icon} />,
    //     link: '/user/chat'
    // },

    {
        key: 'Tutorials',
        label: 'Tutorials',
        renderContent: classes => <OndemandVideo className={classes.icon} />,
        link: '/user/tutorials'
    },

    {
        key: 'Help',
        label: 'Help',
        renderContent: classes => <Help className={classes.icon} />,
        link: '/help'
    },

    // {
    //     key: 'holiday',
    //     label: 'Holidays',
    //     renderContent: classes => <ListAlt className={classes.icon} />,
    //     link: '/holiday'
    // },

    // {
    //     key: 'refer',
    //     label: 'Refer and Earn',
    //     renderContent: classes => <Share className={classes.icon} />,
    //     link: '/refer'
    // },
    // {
    //     key: 'help',
    //     label: 'Help',
    //     renderContent: classes => <Info className={classes.icon} />,
    //     link: '/user/help'
    // }
];
const navbarAutoProviderItems = [
    {
        key: 'home',
        label: 'Home',
        renderContent: classes => <Home className={classes.icon} />,
        // link: '/user/dashboard'
        link: '/provider/dashboard'
    },
    {
        key: 'Profile',
        label: 'Profile',
        renderContent: classes => <Person className={classes.icon} />,
        link: '/user/profile'
    },

    {
        key: 'notifications',
        label: 'Notifications',
        renderContent: classes => <Notifications className={classes.icon} />,
        link: '/notification/list'
    },

    // {
    //     key: 'inbox',
    //     label: 'Chat',
    //     renderContent: classes => <Email className={classes.icon} />,
    //     link: '/user/chat'
    // },

    {
        key: 'address',
        label: 'Addresses',
        renderContent: classes => <Home className={classes.icon} />,
        link: '/user/address'
    },

    {
        key: 'booking',
        label: 'Manage Requests',
        renderContent: classes => <Edit className={classes.icon} />,
        link: '/provider/booking'
    },

    // {
    //     key: 'service',
    //     label: 'Manage Services',
    //     renderContent: classes => <ListAlt className={classes.icon} />,
    //     link: '/provider/service'
    // },

    // {
    //     key: 'addservice',
    //     label: 'Add Service',
    //     renderContent: classes => <Edit className={classes.icon} />,
    //     link: '/provider/service/create'
    // },
    // {
    //     key: 'employee',
    //     label: 'Manage Employee',
    //     renderContent: classes => <ListAlt className={classes.icon} />,
    //     link: '/employees'
    // },

    // {
    //     key: 'review',
    //     label: 'Review and Rating',
    //     renderContent: classes => <Star className={classes.icon} />,
    //     link: '/review'
    // },

    {
        key: 'holiday',
        label: 'Holidays',
        renderContent: classes => <ListAlt className={classes.icon} />,
        link: '/holiday'
    }, {
        key: 'refer',
        label: 'Refer and Earn',
        renderContent: classes => <Share className={classes.icon} />,
        link: '/refer'
    },
    // {
    //     key: 'help',
    //     label: 'Help',
    //     renderContent: classes => <Info className={classes.icon} />,
    //     link: '/user/help'
    // }
];
var notification_count = 0;
const inbox_count = 0;
export class SideNav extends Component {
    constructor() {
        super();
        this.state = {
            notification_count: 0,
            inbox_count: 0,
        }
    }
    componentDidMount() {
        console.log("skskskskks", this.props.isMainPage)
        if (authToken !== 'Guest') {
            this.props.userProfileAction(this.onDone);
        }
        this.reloadData = setInterval(() => {
            // this.props.userProfileAction(this.onDone);
            console.log("modified web 1")
        }, 50000000)
    }
    componentWillUnmount() {
        clearInterval(this.reloadData)
    }
    onDone = (sucess, data) => {
        if (sucess) {
            this.setState({
                notification_count: data.detail.notification_count,
                inbox_count: data.detail.inbox_count
            })
        } else {
            this.setState({
                notification_count: 0,
                inbox_count: 0
            })
        }
    }
    renderCustomerNavbar = formatMessage => {
        // console.log("101");
        {
            return navbarItems.map(n => {
                return (
                    <li key={n.key} className="custom-hover-drawer custom-focus-drawer">
                        <NavLink to={n.link} activeStyle={{ fontWeight: "bold", backgroundColor: "#0078FF", margin: 0 }} className='active-sidenav-item'>
                            <ListItem>
                                <ListItemIcon >
                                    {n.renderContent(this.props.classes)}
                                </ListItemIcon>
                                <ListItemText
                                    className={
                                        this.props.classes.listItem + ' pl-0'
                                    }
                                    primary={formatMessage({
                                        id: n.key
                                    })}
                                    primaryTypographyProps={{
                                        className: this.props.classes.listItem
                                    }}
                                />
                                {n.key == "notifications" && <ListItemSecondaryAction>
                                    {this.state.notification_count > 0 && <div className="notifications_pad" style={{
                                        background: "#EA1616", width: 30, height: 30, borderRadius: 360, textAlign: "center", padding: "4px 8px"
                                    }}>
                                        <p style={{ fontSize: 10, color: "#ffffff" }}> {Number(this.state.notification_count) > 25 ?
                                            "25+" : this.state.notification_count
                                        }</p>
                                    </div>}
                                </ListItemSecondaryAction>}

                                {n.key == "inbox" && <ListItemSecondaryAction>
                                    {this.state.inbox_count > 0 && <div className="notifications_pad" style={{
                                        background: "#EA1616", width: 30, height: 30, borderRadius: 360, textAlign: "center", padding: "4px 8px"
                                    }}>
                                        <p style={{ fontSize: 10, color: "#ffffff" }}> {Number(this.state.inbox_count) > 25 ?
                                            "25+" : this.state.inbox_count
                                        }</p>
                                    </div>}
                                </ListItemSecondaryAction>}
                            </ListItem>
                        </NavLink>
                    </li>
                );
            });
        }
    };

    renderCustomerNavbarTwo = formatMessage => {
        // console.log("202");
        {
            return navbarItemsonlynotification.map(n => {
                return (
                    <li key={n.key} className="custom-hover-drawer custom-focus-drawer">
                        <Link to={n.link}>
                            <ListItem>
                                <ListItemIcon >
                                    {n.renderContent(this.props.classes)}
                                </ListItemIcon>
                                <ListItemText
                                    className={
                                        this.props.classes.listItem + ' pl-0'
                                    }
                                    primary={formatMessage({
                                        id: n.key
                                    })}
                                    primaryTypographyProps={{
                                        className: this.props.classes.listItem
                                    }}
                                />
                                {n.key == "notifications" && <ListItemSecondaryAction>
                                    {this.state.notification_count > 0 && <div className="notifications_pad" style={{
                                        background: "#EA1616", width: 30, height: 30, borderRadius: 360, textAlign: "center", padding: "4px 8px"
                                    }}>
                                        <p style={{ fontSize: 10, color: "#ffffff" }}> {Number(this.state.notification_count) > 25 ?
                                            "25+" : this.state.notification_count
                                        }</p>
                                    </div>}
                                </ListItemSecondaryAction>}
                            </ListItem>
                        </Link>
                    </li>
                );
            });
        }
    };

    renderProviderNavbar = formatMessage => {
        console.log("pro 101");
        {
            return navbarProviderItems.map(n => {
                return (
                    // <li key={n.key} className="custom-hover-drawer custom-focus-drawer"> // removed hover from sideNav
                    <li key={n.key} className="custom-focus-drawer">
                        <NavLink to={n.link} activeStyle={{ fontWeight: "bold", backgroundColor: "#0078FF", margin: 0 }}>
                            <ListItem>
                                <ListItemIcon >
                                    {n.renderContent(this.props.classes)}
                                </ListItemIcon>
                                <ListItemText
                                    className={
                                        this.props.classes.listItem + ' pl-0'
                                    }
                                    primary={formatMessage({
                                        id: n.key
                                    })}
                                    primaryTypographyProps={{
                                        className: this.props.classes.listItem
                                    }}
                                />
                                {n.key == "notifications" && <ListItemSecondaryAction>
                                    {this.state.notification_count > 0 && <div className="notifications_pad" style={{
                                        background: "#EA1616", width: 30, height: 30, borderRadius: 360, textAlign: "center", padding: "4px 8px"
                                    }}>
                                        <p style={{ fontSize: 10, color: "#ffffff" }}> {Number(this.state.notification_count) > 25 ?
                                            "25+" : this.state.notification_count
                                        }</p>
                                    </div>}
                                </ListItemSecondaryAction>}
                                {n.key == "inbox" && <ListItemSecondaryAction>
                                    {this.state.inbox_count > 0 && <div className="notifications_pad" style={{
                                        background: "#EA1616", width: 30, height: 30, borderRadius: 360, textAlign: "center", padding: "4px 8px"
                                    }}>
                                        <p style={{ fontSize: 10, color: "#ffffff" }}> {Number(this.state.inbox_count) > 25 ?
                                            "25+" : this.state.inbox_count
                                        }</p>
                                    </div>}
                                </ListItemSecondaryAction>}


                            </ListItem>
                        </NavLink>

                    </li>
                );
            });
        }
    };

    renderAutoProviderNavbar = formatMessage => {
        console.log("pro 202");
        {
            return navbarAutoProviderItems.map(n => {
                return (
                    <li key={n.key} className="custom-hover-drawer custom-focus-drawer">
                        <Link to={n.link}>
                            <ListItem>
                                <ListItemIcon >
                                    {n.renderContent(this.props.classes)}
                                </ListItemIcon>
                                <ListItemText
                                    className={
                                        this.props.classes.listItem + ' pl-0'
                                    }
                                    primary={formatMessage({
                                        id: n.key
                                    })}
                                    primaryTypographyProps={{
                                        className: this.props.classes.listItem
                                    }}
                                />
                                {n.key == "notifications" && <ListItemSecondaryAction>
                                    {this.state.notification_count > 0 && <div className="notifications_pad" style={{
                                        background: "#EA1616", width: 30, height: 30, borderRadius: 360, textAlign: "center", padding: "4px 8px"
                                    }}>
                                        <p style={{ fontSize: 10, color: "#ffffff" }}> {Number(this.state.notification_count) > 25 ?
                                            "25+" : this.state.notification_count
                                        }</p>
                                    </div>}
                                </ListItemSecondaryAction>}

                                {n.key == "inbox" && <ListItemSecondaryAction>
                                    {this.state.inbox_count > 0 && <div className="notifications_pad" style={{
                                        background: "#EA1616", width: 30, height: 30, borderRadius: 360, textAlign: "center", padding: "4px 8px"
                                    }}>
                                        <p style={{ fontSize: 10, color: "#ffffff" }}> {Number(this.state.inbox_count) > 25 ?
                                            "25+" : this.state.inbox_count
                                        }</p>
                                    </div>}
                                </ListItemSecondaryAction>}
                            </ListItem>
                        </Link>

                    </li>
                );
            });
        }
    };

    renderUnverifiedProviderNavbar = formatMessage => {
        console.log("pro 303");
        {
            return navbarUnverifiedProviderItems.map(n => {
                return (
                    // <li key={n.key} className="custom-hover-drawer custom-focus-drawer">
                    //     <NavLink to={n.link} activeStyle={{ fontWeight: "bold", backgroundColor: "#0078FF", margin: 0 }}>
                    //         <Link to={n.link}>
                    //             <ListItemIcon>
                    //                 {n.renderContent(this.props.classes)}
                    //             </ListItemIcon>
                    //             <ListItemText
                    //                 className={
                    //                     this.props.classes.listItem + ' pl-0'
                    //                 }
                    //                 primary={formatMessage({
                    //                     id: n.key
                    //                 })}
                    //                 primaryTypographyProps={{
                    //                     className: this.props.classes.listItem
                    //                 }}
                    //             />
                    //         </Link>
                    //     </NavLink>
                    // </li>
                    <li key={n.key} className="custom-focus-drawer">
                    <NavLink to={n.link} activeStyle={{ fontWeight: "bold", backgroundColor: "#ffffff", margin: 0 }}>
                        <ListItem>
                            <ListItemIcon >
                                {n.renderContent(this.props.classes)}
                            </ListItemIcon>
                            <ListItemText
                                className={
                                    this.props.classes.listItem + ' pl-0'
                                }
                                primary={formatMessage({
                                    id: n.key
                                })}
                                primaryTypographyProps={{
                                    className: this.props.classes.listItem
                                }}
                            />

                        </ListItem>
                    </NavLink>

                </li>
                );
            });
        }
    };

    render() {
        const { formatMessage } = this.props.intl;
        const { userData } = this.props;
        drawerTextColor = "#000000"
        return (

            <List  >
                {/* {this.props.userData.role == ROLE_CUSTOMER && this.props.isMainPage ? 
                 this.renderCustomerNavbarTwo(formatMessage, this.state.notification_count)
                 : 
                    this.renderCustomerNavbar(formatMessage, this.state.notification_count)} */}
                {/* {this.props.userData.role == ROLE_CUSTOMER &&
                
                this.renderCustomerNavbar(formatMessage, this.state.notification_count)} */}
                {
                    this.props.userData.role == ROLE_CUSTOMER && this.props.isMainPage
                        ? this.renderCustomerNavbarTwo(formatMessage, this.state.notification_count)
                        :
                        (
                            (this.props.userData.role == ROLE_CUSTOMER)
                                ? this.renderCustomerNavbar(formatMessage, this.state.notification_count)
                                : ''
                        )
                }



                {this.props.userData.role == ROLE_PROVIDER && (this.props.userData.under_review != '1' || userData.rejected) &&
                    this.renderUnverifiedProviderNavbar(formatMessage)}

                {(this.props.userData.role == ROLE_PROVIDER && this.props.settings.constants.serviceAssignment == 'auto'

                    && this.props.userData.under_review == '1'
                    && !userData.rejected && !userData.show_underreview)
                    ?
                    this.renderProviderNavbar(formatMessage, this.state.notification_count)
                    : null
                    // this.props.userData.role == ROLE_PROVIDER &&
                    // !userData.rejected && userData.show_underreview &&
                    // // this.props.userData.under_review == '1' &&
                    // this.renderAutoProviderNavbar(formatMessage, this.state.notification_count)
                }

            </List>
        );
    }
}

const mapStateToProps = ({ settings, auth }) => {
    return { settings: settings, colors: settings.colors, userData: auth.userData };
};
const composedComponent = compose(
    withTheme(),
    withStyles(styles),
    connect(mapStateToProps, null)
);

export default composedComponent(injectIntl(SideNav));



// WEBPACK FOOTER //
// ./src/views/SideBar/SideNav.jsx